import axios from "axios";

export const getNewISTDateTime = () => {
  const now = new Date();
  // Convert to IST offset (UTC +5:30)
  const istOffset = 5.5 * 60 * 60 * 1000;
  const istTime = new Date(now.getTime() + istOffset);
  const day = String(istTime.getUTCDate()).padStart(2, "0");
  const month = String(istTime.getUTCMonth() + 1).padStart(2, "0");
  const year = istTime.getUTCFullYear();

  const hours = String(istTime.getUTCHours()).padStart(2, "0");
  const minutes = String(istTime.getUTCMinutes()).padStart(2, "0");
  const seconds = String(istTime.getUTCSeconds()).padStart(2, "0");

  const date = `${day}-${month}-${year}`;
  const time = `${hours}:${minutes}:${seconds}`;

  return { date, time };
};

export const doAuditLog = async(action, componentName, olderData, newerData) => {

    try {
       
      const updateByUserRole = sessionStorage.getItem("role");
      const updateByUserEmail = sessionStorage.getItem("userEmail");
      const updateByUserFullName = sessionStorage.getItem("userFullName");
      const updateByUserId = sessionStorage.getItem("userId");
      const updateByUserMobile = sessionStorage.getItem("userMobile");
      const updateByUserName = sessionStorage.getItem("userName");
      const companyKey = sessionStorage.getItem("companyKey");
      const {date, time} = getNewISTDateTime();

      const payload = {
        action,
        componentName,
        updateByUserRole,
        updateByUserEmail,
        updateByUserFullName,
        updateByUserId,
        updateByUserMobile,
        // updateByUserName,
        oldData: (typeof olderData === "string" && olderData !== "")
        ? olderData
        : (olderData ? JSON.stringify(olderData) : null),
        newData: (typeof newerData === "string" && newerData !== "")
        ? newerData
        : (newerData ? JSON.stringify(newerData) : null),
        updateDate: date,
        updatedTime: time,
        companyKey,
      }

      await axios.post(
        "https://api.dremerz.net/api/DZ_8925_PayrollProduct_History_AuditLog_AllLogs",
        payload
      );
    } catch (error) {
      console.error("Failed to save edit history:", error);
    }
  };